/* global ol */

function EditRouteInteraction(map) {
  this.map = map;

  this.interaction = new ol.interaction.Select({
    addCondition: ol.events.condition.singleClick,
    toggleCondition: ol.events.condition.never,
    layers: [].concat(this.map.layers('routeLayers'), this.map.layers('carLayers')),
    style: []
  });

  this.interaction.on('select', this.onSelect.bind(this));
}

EditRouteInteraction.prototype.onSelect = function(event) {
  var selected = event.selected[0];
  var route = selected.get('route') || selected.get('features')[0].get('stop').route;

  this.interaction.getFeatures().clear(); // Makes the feature reselectable
  this.map.tooltip.hideTooltip();
  this.map.scope.openEditRoute(event, route);
};

module.exports = EditRouteInteraction;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/editRouteInteraction.js
 ** module id = 177
 ** module chunks = 1
 **/